import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainRetrySetSocketNum(data) {
  return maintainRequest({
    url: `/device/maintenanceMan/socketManage/retrySetTwoWaySocket`,
    method: "post",
    data,
  });
}
